import React, { useState, useEffect } from "react";
import { Modal, Button } from 'react-bootstrap';
import { TextField } from "@mui/material/";
import axios from "axios";
import moment from 'moment';
import CommonModal from './CommonModal';
// import DropDown from './DropDown';
import Select from "react-select";
import { ToastContainer, toast } from 'react-toastify';

export default function EditConditions(props) {
	const [checkbox, setCheckbox] = useState(false);
  const[dropDownData,setDropDownData]  = useState(null);
  const [dropdownRows, setDropdownRows] = useState([
    { type: "", comparator: "", value: "", valueOptions: [] }
  ]);
	const closePopup = () => {
    setDropdownRows([]);
		props.setShowPopup(false);
    props.setConditionLoader(true)
	};

  const fetchOptions = async (type, selectedState = '') => {
    let url = `/v2/playlists/player_options?type=${type}`;
    if (type === 'city' && selectedState) {
      url += `&state=${selectedState}`;
    }
    const res = await axios.get(url);
    return res.data;
  };
  const handleTypeChange = async (index, selectedType) => {
    const updatedRows = [...dropdownRows];
    updatedRows[index].type = selectedType;
    updatedRows[index].comparator = "";
    updatedRows[index].value = "";
    updatedRows[index].valueOptions = [];

    if (selectedType === "PLAYER_CITY") {
      const options = await fetchOptions('city');
      updatedRows[index].valueOptions = options.map((val) => ({
        label: val,
        value: val,
      }));
    } else if (selectedType === "PLAYER_STATE") {
      const options = await fetchOptions('state');
      updatedRows[index].valueOptions = options.map((val) => ({
        label: val,
        value: val,
      }));
    }
      else if (selectedType === "Display_Tags") {
      const options = await fetchOptions('display_tags');
      updatedRows[index].valueOptions = options.map((val) => ({
        label: val.name,
        value: val.id,
      }));
    } 
    setDropdownRows(updatedRows);
  };

  const handleComparatorChange = (index, selectedComparator) => {
    const updatedRows = [...dropdownRows];
    updatedRows[index].comparator = selectedComparator;
    setDropdownRows(updatedRows);
  };

  const handleValueChange = (index, selectedValue) => {
    const updatedRows = [...dropdownRows];
    updatedRows[index].value = selectedValue;
    setDropdownRows(updatedRows);
    setDropDownData(selectedValue)
  };

  const addMoreDropdownRow = () => {
    setDropdownRows([...dropdownRows, { type: "", comparator: "", value: "", valueOptions: [] }]);
  };

  const removeDropdownRow = (indexToRemove) => {
    const updatedRows = dropdownRows.filter((_, index) => index !== indexToRemove);
    setDropdownRows(updatedRows);
  };

  const updatedSetConditions=()=> {
      if (!validateDropdownRows()) {
        notify('Please fill all the values before set.', 'error')
    return;
  }
    const cleanedConditions = dropdownRows.map(({ type, comparator, value }) => ({
      type,
      comparator,
      value
    }));
    props.conditionDataToSet(cleanedConditions)
    props.setShowPopup(false);
    props.setConditions(cleanedConditions);
  };

  const initializeDropdownRows = async () => {
    if (props.initialConditions && props.initialConditions.length > 0) {
      const rows = await Promise.all(
        props.initialConditions.map(async (condition) => {
          let valueOptions = [];
          if (condition.type === "PLAYER_CITY") {
            valueOptions = await fetchOptions('city');
          } else if (condition.type === "PLAYER_STATE") {
            valueOptions = await fetchOptions('state');
          }
          else if (condition.type === "Display_Tags") {
            valueOptions = await fetchOptions('display_tags');
          }
          valueOptions = valueOptions.map(val => (
            typeof val === "string" ? { label: val, value: val } : { label: val.name, value: val.id }
          ));
          return {
            type: condition.type,
            comparator: condition.comparator,
            value: condition.value,
            valueOptions
          };
        })
      );
      setDropdownRows(rows);

    } else {
      setDropdownRows([{ type: "", comparator: "", value: "", valueOptions: [] }]);
    }
    props.setConditionLoader(false)
  };

  useEffect(() => {
    props.show && initializeDropdownRows();
  }, [props.show]);
 
  const customStyles = {
    control: (provided) => ({
      ...provided,
      border: 'none', 
      boxShadow: 'none', 
      borderLeft: 'none',
      borderRight: 'none',
      borderBottom: '1px solid', 
      borderRadius: 0,
      backgroundColor: 'transparent',
    }),
  };


  const validateDropdownRows = () => {
    for (const row of dropdownRows) {
      if (!row.type || !row.comparator || !row.value) {
        return false;
      }
    }
    return true;
  };

  const notify = (msg, type) => {

    switch (type) {
      case 'success':
        toast.success(msg);
        break;
      case 'error':
        toast.error(msg);
        break;
    }
  }
	return (
		<div>
			<div className="App p-4">
				<Modal size="xl" centered show={props.show} onHide={closePopup}>
					<Modal.Header closeButton>
            <Modal.Title className="d-flex align-items-center">
              {props.title}

              <span className="m-2 text-primary">-
              </span>
              <span className="text-decoration-underline">{props.showContentName}</span>
            </Modal.Title>
					</Modal.Header>
          <Modal.Body>
            {!props.conditionLoader ? dropdownRows.map((row, index) => (
              <div key={index} className="d-flex align-items-center gap-3  mb-3">
                {/* Type Dropdown */}
                <div style={{width:'40rem'}}>
                  <select
                    className="form-select w-20"
                    value={row.type}
                    onChange={(e) => handleTypeChange(index, e.target.value)}
                  >
                    <option value="">Select Type</option>
                    <option value="PLAYER_STATE">Player State</option>
                    <option value="PLAYER_CITY">Player City</option>
                    <option value="Display_Tags">Player Tags</option>
                  </select>
                </div>

                {/* Comparator Dropdown */}
                <div style={{width:'40rem'}}>
                <select isSearchable
                  className="form-select w-20"
                  value={row.comparator}
                  onChange={(e) => handleComparatorChange(index, e.target.value)}
                >
                  <option value="">Select Option</option>
                  <option value="IS">IS</option>
                  <option value="ISNOT">IS NOT</option>
                </select>
                </div>
                
                <div style={{width:'50rem'}}>
                  <Select
                    className="w-60 withoutBorder"
                    styles={customStyles} 
                    isSearchable
                    placeholder="Select Value"
                    options={row.valueOptions}
                    value={row.valueOptions.find(opt => opt.value === row.value) || null}
                    onChange={(selected) => handleValueChange(index, selected.value)}
                  />
                </div>
                

                {/* Remove Icon */}
                <button
                  className="btn btn-link text-danger p-0 mt-3"
                  onClick={() => removeDropdownRow(index)}
                  style={{ fontSize: "15px" }}
                >
                  <i className="fa fa-trash"></i>
                </button>

              </div>
            )): 
            (
              <div className="text-center fs-5 text-secondary mb-3">
                Please wait, conditions are loading...
              </div>
            )}
            {!props.conditionLoader ? (
              dropdownRows.length < 20 ? (
                <div className="d-flex justify-content-start mb-3">
                  <a href="#" onClick={(e) => { e.preventDefault(); addMoreDropdownRow(); }}>
                    + Add More
                  </a>
                </div>
              ) : (
                <div className="text-danger mb-3">
                  Maximum limit reached: You can add up to 20 options.
                </div>
              )
            ) : null}
          </Modal.Body>
				<Modal.Footer>
					<button className="btn btn-save-button" onClick={updatedSetConditions}>Set</button>
					<button className="btn btn-save-button" onClick={closePopup}>Cancel</button>
				</Modal.Footer>
			</Modal>
			</div>
		</div>
	);
}



